/* eslint-disable */

import SideBar from "../../SideBar";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { FaCashRegister, FaFileMedical, FaFileExcel, FaRegEdit, FaRegTrashAlt } from "react-icons/fa";
import apiInstance from "../../../../utils/api";
import ReagentDialog from "./ReagentDialog";

function CatRegister() {
  const [open, setOpen] = useState(false);
  const [reagent, setReagent] = useState([]);
  const [showSearch, setShowSearch] = useState(false);
  const [showOri, setShowOri] = useState(true);
  const handleDelete = (event) => {
    console.log(event, "event");
    apiInstance
      .delete("reagent-list/" + event)
      .then((response) => {
        Swal.fire({
          title: "Success",
          text: "Successfully Deleted!",
          icon: "success",
          confirmButtonText: "OK",
        });
        const result = reagent.filter((item) => item._id !== event);
        setReagent(result);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error.response.data.message,
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      });
  };
  const showDialog = () => setOpen(true);
  useEffect(() => {
    const getReagent = async () => {
      try {
        const res = await apiInstance.get("reagent-list");

        setReagent(res.data.data);
      } catch (err) { }
    };
    getReagent();
  }, []);
  return (
    <div classNameName='App'>
      {/* <!-- end preloader --> */}
      {/* @include('sweet::alert') */}

      <div className='wrapper'>
        <SideBar />
        {/* <!-- Content Wrapper. Contains page content --> */}

        <div className='content-wrapper'>
          {/* <!-- Content Header (Page header) --> */}
          <div className='content-header'>
            <div className='container-fluid'>
              <div className='row mb-2'>
                <div className='col-sm-12'>
                  <ol className='breadcrumb'>
                    <li className='breadcrumb-item'>
                      <a href='/lab-test'>Home</a>
                    </li>
                    <li className='breadcrumb-item active'>Reagent List</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Main content --> */}

          <section className='content'>
            <div className='container-fluid'>
              <div className='row'>
                <div class='row'>
                  <div class='col-md-12 py-3 card'>
                    <div class='card-header'>
                      <div class='row justify-content-between'>
                        <label class=''>
                          <span class='float-right'>
                            {/* <Link to='/reagent-reg' class='btn btn-primary'>
                              <i class='fas fa-plus'></i> &nbsp;Add
                            </Link> */}


                            <button
                              type='button'
                              style={{
                                backgroundColor: "#0b9490",
                                color: "white",
                                borderRadius: "7px",
                              }}
                              className='btn  ml-5'
                              onClick={showDialog}
                            >
                              <i class='fas fa-plus'></i> &nbsp;Add
                            </button>

                            &nbsp;
                            {/* <a href="/expense_type" class="btn btn-primary">
                              Expense Type
                            </a> */}
                            <button
                              type='button'
                              className='btn btn-success'
                            // onClick={excelExport}
                            >
                              <FaFileExcel />
                              &nbsp;Export
                            </button>
                          </span>
                        </label>
                      </div>
                      <div class='row' id='trial_balance'></div>
                    </div>
                    <div className='row'>
                      <div className='col-md-12'>
                        <div className='table-responsive' id='slimtest2'>
                          <table className='table table-hover' id='filter_date'>
                            <thead className=''>
                              <tr>
                                <th>#</th>
                                <th>Code</th>
                                <th>Name</th>

                                <th>Category</th>

                                <th>Description</th>
                                <th>Unit</th>
                                <th className='text-center'>Action</th>
                              </tr>
                            </thead>
                            {showOri && (
                              <tbody className=''>
                                {reagent[0] ? reagent.map((item, i) => (
                                  <tr>
                                    <td>{++i}</td>
                                    <td>{item.code}</td>
                                    <td>{item.name}</td>

                                    <td>
                                      {item.relatedCategory
                                        ? item.relatedCategory.name
                                        : ""}
                                    </td>


                                    <td>{item.description}</td>
                                    <td className='r'>
                                      <Link to={"/reagent-unit/" + item._id}>
                                        <p
                                          className='btn btn-sm'
                                          style={{
                                            backgroundColor: "#0b9490",
                                            color: "white",
                                          }}
                                        >
                                          Unit
                                        </p>
                                      </Link>
                                    </td>
                                    <td className='text-center'>
                                      <Link
                                        to={"/reagent-update/" + item._id}
                                        className='btn btn-sm btn-warning'
                                      >
                                        <FaRegEdit />
                                      </Link>
                                      &nbsp;
                                      <button
                                        className='btn btn-sm btn-danger'
                                        onClick={(e) => submit(item._id)}
                                      >
                                        <FaRegTrashAlt />
                                      </button>
                                    </td>
                                  </tr>
                                )) : (
                                  <div className='py-3 d-flex justify-content-center'>

                                    {/* <img src={SearchIcon} width='70px' /> */}
                                    <span className='text-md'>Loading . . .</span>

                                  </div>
                                )}
                              </tbody>
                            )}
                            {showSearch && (
                              <tbody className=''>
                                {reagent.map((medicineList, i) => (
                                  <tr>
                                    <td>{++i}</td>
                                    <td>{medicineList.code}</td>
                                    <td>{medicineList.name}</td>
                                    <td>
                                      {medicineList.relatedBrand
                                        ? medicineList.relatedBrand.name
                                        : ""}
                                    </td>
                                    <td>
                                      {medicineList.relatedCategory
                                        ? medicineList.relatedCategory.name
                                        : ""}
                                    </td>

                                    <td>
                                      {medicineList.relatedSubCategory
                                        ? medicineList.relatedSubCategory.name
                                        : ""}
                                    </td>
                                    <td>{medicineList.description}</td>
                                    <td className=''>
                                      <Link to={"/unit/" + medicineList._id}>
                                        <p className='btn btn-sm btn-primary'>
                                          Unit
                                        </p>
                                      </Link>
                                    </td>
                                    <td className='text-center'>
                                      <Link
                                        to={"/medUp/" + medicineList._id}
                                        className='btn btn-sm btn-warning'
                                      >
                                        <FaRegEdit />
                                      </Link>
                                      &nbsp;
                                      <button
                                        className='btn btn-sm btn-danger'
                                        onClick={(e) =>
                                          submit(medicineList._id)
                                        }
                                      >
                                        <FaRegTrashAlt />
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            )}
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <ReagentDialog
                open={open}
                setOpen={setOpen}
                close={() => setOpen(false)}
                setReagent={setReagent}
                reagent={reagent}
              />
            </div>
            {/*<!-- /.container-fluid --> */}
          </section>
        </div>
      </div>

      {/* <!-- /.content-wrapper --> */}
      <footer className='main-footer'>
        <strong>
          Copyright &copy; 2017-2020{" "}
          <a href='http://www.kwintechnologies.com'>K-win Technology</a>.
        </strong>
        All rights reserved.
      </footer>

      {/* <!-- Control Sidebar --> */}
      <aside classNameName='control-sidebar control-sidebar-dark'>
        {/* <!-- Control sidebar content goes here --> */}
      </aside>
      {/* <!-- /.control-sidebar --> */}

      {/* <!-- ./wrapper --> */}
    </div>
  );
}
export default CatRegister;
